
import { Vue, Component } from "vue-property-decorator";
import hotVideoItem from "./components/hot-video-item/index.vue";
import premiumVideoItem from "./components/premium-video-item/index.vue";
import customSwiper from "./components/custom-swiper/index.vue";
import newsItem from "./components/news-item/index.vue";
import paikeItem from "./components/paike-item/index.vue";
import request from "@/api/index";
import {
  commonJumpNewsDetail,
  setWechatShare
} from "@/views/kaizhou-shuai-video/hooks";
import { PullRefresh } from "vant";

@Component({
  name: "kzvideo",
  methods: { commonJumpNewsDetail },
  components: {
    "hot-video-item": hotVideoItem,
    "premium-video-item": premiumVideoItem,
    "custom-swiper": customSwiper,
    "news-item": newsItem,
    "van-pull-refresh": PullRefresh,
    "paike-item": paikeItem
  }
})
export default class index extends Vue {
  shuaiKzColumId = 32077;
  // 正式环境栏目id
  prodColumnId = {
    hotVideoColumnId: "99324546", //热点视频栏目ID

    premiumVideoId: "99324547", //精品视频栏目ID

    videoColumnId: "99324548", //视频专栏ID

    liveReviewId: "99324549", //直播回看ID

    paiKeId: "99324550", //拍客ID

    whisperId: "99324551" //湖畔轻语栏目ID
  };

  // 预发布环境栏目id
  releaseColumnId = {
    hotVideoColumnId: "101090683", //热点视频栏目ID

    premiumVideoId: "101090684", //精品视频栏目ID

    videoColumnId: "101090685", //视频专栏ID

    liveReviewId: "101090686", //直播回看ID

    paiKeId: "101090687", //拍客ID

    whisperId: "101090688" //湖畔轻语栏目ID
  };

  envId = {
    hotVideoColumnId: "", //热点视频栏目ID

    premiumVideoId: "", //精品视频栏目ID

    videoColumnId: "", //视频专栏ID

    liveReviewId: "", //直播回看ID

    paiKeId: "", //拍客ID

    whisperId: "" //湖畔轻语栏目ID
  };

  hotVideo = []; //热点视频

  premiumVideo = []; //精品视频

  videoColumn = []; //视频专栏

  liveReview = []; //直播回看

  paiKe = []; //拍客

  whisper = []; //湖畔轻语

  shuaiVideo = []; //帅视频栏目普通新闻

  created() {
    if (process.env.NODE_ENV === "production") {
      this.envId = this.prodColumnId;
    } else {
      this.envId = this.releaseColumnId;
    }
    this.getList();

    setWechatShare();
  }

  activated() {
    setWechatShare();
  }

  async getList(callback?: Function) {
    const promise1 = this.getDisplayList(this.envId.hotVideoColumnId).then(
      (res: any) => {
        this.hotVideo = res.slice(0, 4);
      }
    );
    const promise2 = this.getDisplayList(this.envId.premiumVideoId).then(
      (res: any) => {
        this.premiumVideo = res.slice(0, 2);
      }
    );
    const promise3 = this.getDisplayList(this.envId.videoColumnId).then(
      (res: any) => {
        this.videoColumn = res.slice(0, 5);
      }
    );
    const promise4 = this.getDisplayList(this.envId.liveReviewId).then(
      (res: any) => {
        this.liveReview = res.slice(0, 5);
      }
    );
    const promise5 = this.getDisplayList(this.envId.whisperId).then(
      (res: any) => {
        this.whisper = res.slice(0, 3);
      }
    );
    const promise6 = this.getDisplayList(this.envId.paiKeId).then(
      (res: any) => {
        this.paiKe = res.slice(0, 2);
      }
    );
    const promise7 = request.listNews(this.shuaiKzColumId).then((res: any) => {
      this.shuaiVideo = res.data.filter((item: any) =>
        [
          "NO_IMG",
          "ONE_IMG",
          "BIG_IMG",
          "NARROW_IMG",
          "NARROW_IMG_TITLE",
          "MULTI_IMG",
          "PLAY_VIDEO",
          "PLAY_VIDEO_TITLE",
          "LIVE@1"
        ].includes(item.listViewCode)
      );
    });

    Promise.all([
      promise1,
      promise2,
      promise3,
      promise4,
      promise5,
      promise6,
      promise7
    ]).then(() => {
      callback && callback();
    });
  }

  async getDisplayList(ids: string): Promise<[]> {
    const temp = await request.seatNews(ids);
    return temp.data[0].data;
  }

  // 跳转列表页
  toList(name: string, ids: string, type?: string, title?: string) {
    this.$router.push({
      name,
      query: {
        ids,
        type,
        title
      }
    });
  }

  isLoading = false;
  onRefresh() {
    this.getList(() => (this.isLoading = false));
  }
}
